import { useFileUpload } from 'hooks/fines/useUploadFine';
import React from 'react';
import { FileUploadProps } from 'utils/types';
import { FileUploadUI } from './FileUpload';

export const FileUpload: React.FC<FileUploadProps> = (props) => {
  const hookProps = useFileUpload(props);
  return <FileUploadUI {...props} {...hookProps} />;
};
